/**
 * Trigger a browser download of `data` serialized as pretty-printed JSON. Mirrors the
 * Blob → object-URL → anchor → click → revoke pattern in DataSetService.downloadDataSetAsCsv,
 * extracted here so the chat export (and any future JSON export) can reuse it without a service
 * round-trip. `filename` should already be sanitized by the caller.
 */
export const downloadJson = (filename: string, data: unknown): void => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
};
